import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const evidenceModel = [
  ['Context', 'The users, operating problem, and constraints the work had to respect.'],
  ['Delivered work', 'The product, workflow, integration, or capability Nalexus was responsible for.'],
  ['Evidence', 'Outcomes supported by approved, attributable facts—without invented metrics.'],
];

export default function CaseStudiesPage() {
  useEffect(() => {
    document.title = 'Case Studies | Nalexus Technologies';
  }, []);

  return (
    <main id="main-content" className="sync-main sync-subpage">
      <section className="sync-page-hero sync-section">
        <div className="sync-shell sync-page-hero-grid">
          <div>
            <p className="sync-eyebrow">Case studies</p>
            <h1>Evidence over decoration.</h1>
          </div>
          <div>
            <p className="sync-lead">Public client stories are published only after the scope, outcomes, names, and visual permissions have been verified.</p>
            <p className="sync-availability-note">The current case-study set is under factual and permission review.</p>
            <Link className="sync-text-link" to="/products">Explore Nalexus products <span aria-hidden="true">→</span></Link>
          </div>
        </div>
      </section>

      <section className="sync-section" aria-labelledby="case-study-standard-heading">
        <div className="sync-shell">
          <div className="sync-section-heading">
            <p className="sync-kicker">Publishing standard</p>
            <h2 id="case-study-standard-heading">Every story should make the work clear.</h2>
          </div>
          <div className="sync-pillar-grid">
            {evidenceModel.map(([title, text], index) => (
              <article className="sync-card sync-pillar-card" key={title}>
                <span className="sync-card-number">0{index + 1}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="sync-section sync-final-cta">
        <div className="sync-shell sync-final-cta-inner">
          <p className="sync-kicker">Have a system in mind?</p>
          <h2>Let’s define what success should look like before the build begins.</h2>
          <Link className="sync-button" to="/contact">Discuss a project</Link>
        </div>
      </section>
    </main>
  );
}
